import { Link } from 'react-router-dom';
import { Badge, Empty } from "antd";
import LoadingSpinner from '../../../components/LoadingSpinner';
import React from "react";


const MessagesPanel = ({ isLoading, notifications, totalUnread, colClass }) => {
    return (
        <div className={`md:px-3 mb-6 ${colClass}`}>
            <div className="talent-dashboard-panel min-h-[414px]">
                <div className="flex items-center justify-between mb-3">
                    <Badge count={parseInt(totalUnread) || 0}>
                        <h1 className="dashboard-title">
                            Notifications
                        </h1>
                    </Badge>
                    {!isLoading && (
                        <Link
                            to="/talent/notifications"
                            className="btn btn-primary ml-auto self-center"
                        >
                            View All
                        </Link>
                    )}
                </div>

                {isLoading ? (
                    <div className="flex-grow items-center justify-center flex flex-col">
                        <LoadingSpinner size={'lg'} />
                    </div>
                ) : (
                    notifications?.length ? (
                        <div className="flex flex-col divide-ydivide-slate-100 gap-2.5 flex-1">
                            {notifications.map(msg => (
                                <Link
                                    key={msg.id}
                                    to="/talent/notifications"
                                    state={{ selectedMessageId: msg.id }}
                                    className="flex gap-2.5 p-2 no-underline bg-[#F5F6F8] -mx2rounded"
                                >
                                    <div className="pt-1.5 shrink-0">
                                        {!msg.read_at
                                            ? <div className="w-[7px] h-[7px] bg-indigo-500 rounded-full" />
                                            : <div className="w-[7px]" />
                                        }
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <div className="flex items-start justify-between gap-2 mb-[2px]">
                                            <div className={`text-[13px] leading-snug ${!msg.read_at ? 'font-semibold text-slate-900' : 'font-medium text-slate-700'}`}>
                                                {msg.title}
                                            </div>
                                            <div className="text-[11px] text-slate-400 whitespace-nowrap shrink-0">
                                                {TB.moment(msg.created_at).fromNow()}
                                            </div>
                                        </div>
                                        <div className="text-[12px] text-slate-500 leading-normal line-clamp-1">
                                            {(msg.body || '').replace(/<[^>]*>/g, '')}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <Empty
                            className="flex flex-col items-center justify-center flex-grow"
                            image="/images/heads.png"
                            imageStyle={{ height: 60 }}
                            description={(
                                <div className="flex flex-col gap-2 items-center justify-center">
                                    <p className="text-lg">
                                        No Notifications Yet
                                    </p>
                                    <p className="text-sm">
                                        Notifications will appear here.
                                    </p>
                                </div>
                            )}
                        />
                    )
                )}
            </div>
        </div>
    )
}

export default MessagesPanel;